export const getQueryFulfilledError = (exception) => {
    return exception.error;
};
